import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function NewsletterSection() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const hpValue = (formData.get('phone_alt') as string || '').trim();

    if (hpValue) {
      setStatus('success');
      setEmail('');
      return;
    }

    try {
      const res = await fetch('https://readdy.ai/api/form/d974ek4ut53jbls7kumg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          email: formData.get('email') as string,
        }).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // ignore parse error
      }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setStatus('error');
          setErrorMsg(t('newsletter.error'));
        } else {
          setStatus('error');
          setErrorMsg(serverMsg || t('newsletter.error'));
        }
      }
    } catch {
      setStatus('error');
      setErrorMsg(t('newsletter.error'));
    }
  };

  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h3 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            {t('newsletter.title')}
          </h3>
          <p className="text-sm text-foreground-500 mb-8">
            Bądź na bieżąco z najnowszymi znaleziskami i aktualizacjami arkuszy zakupowych.
          </p>

          <form
            onSubmit={handleSubmit}
            data-readdy-form
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              name="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('newsletter.placeholder')}
              className="flex-1 px-5 py-3 rounded-full border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors duration-200"
            />
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="form-hp"
            />
            <button
              type="submit"
              className="px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              {t('newsletter.subscribe')}
            </button>
          </form>

          {status === 'success' && (
            <p className="mt-4 text-sm text-accent-600 font-medium">
              {t('newsletter.success')}
            </p>
          )}
          {status === 'error' && (
            <p className="mt-4 text-sm text-red-500 font-medium">
              {errorMsg}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}